"use client";
import React from "react";

const CheckIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ flexShrink: 0, marginTop: "3px" }}
  >
    <circle
      cx="10"
      cy="10"
      r="9"
      stroke="#3399ff"
      strokeWidth="1.5"
      fill="none"
    />
    <path
      d="M6.5 10L9 12.5L13.5 7.5"
      stroke="#3399ff"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const BULLET_ITEMS = [
  "CMA = CPA (-) Audit (-) Tax. Only 4 exams, 2-16 months",
  "Exams happen 6 months every year (Jan-Feb, May-Jun, Sep-Oct) - you decide your exam date!",
  "3-year window to pass both the exams. Which means you can study for one exam at a time",
  <>
    Exams are objective and 75% computer graded. <strong>75% MCQs</strong> (Kaun
    Banega CMA!) and {""}
    <strong>25% Case-Based Questions</strong>
  </>,
  <>
    Commitment needed: <strong>18-20 hours</strong> of study every week
  </>,
];

interface AI_integreatedProps {
  isCity?: Boolean;
}

const AI_integreated: React.FC<AI_integreatedProps> = ({ isCity }) => {
  return (
    <section className="bg-white py-8 px-4 max-md:bg-[#f3f3f3] max-md:p-4">
      <div className="main_container py-5 bg-white rounded-2xl">
        <h2
          className={`${isCity ? "text-left" : "text-center mx-auto"} text-[32px] font-bold text-[#1d1d1d]  mb-[30px] leading-[1.3] max-w-[700px] max-lg:text-[30px] max-md:text-2xl max-md:max-w-none`}
        >
          <span className="text-[#39f]">AI-Integrated U.S. CMA</span> is
          designed for Professional Members
        </h2>
        <p
          className={`${isCity ? "text-left" : "text-center"} text-[15px] text-[#888] m-0 mb-10 font-semibold leading-[1.5]`}
        >
          But separate category of Student Members who can appear for CMA exams
          alongside UG
        </p>

        <div className="grid grid-cols-2 gap-8 items-end max-md:grid-cols-1 max-md:gap-6">
          {/* Left - bullet points */}
          <div>
            <ul className="list-none p-0 m-0 flex flex-col gap-3">
              {BULLET_ITEMS.map((item, i) => (
                <li
                  key={i}
                  className="flex gap-2.5 text-sm text-[#333] leading-[1.55] [&>strong]:font-bold [&>strong]:text-[#222]"
                >
                  <CheckIcon />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right - pass rate cards */}
          <div className="flex flex-col items-end gap-3 max-md:items-center">
            <div className="grid grid-cols-2 gap-5 w-full max-md:gap-3">
              <div className="bg-[#f5f5f5] px-6 py-5 flex flex-col gap-2 max-md:p-2">
                <span className="text-xs font-bold tracking-[1.5px] text-[#2a85ff] uppercase">
                  GLOBAL PASS RATE
                </span>
                <span className="text-[57px] font-bold text-[#2a85ff] leading-[1.1] max-lg:text-[40px] max-md:text-[42px]">
                  ~45%{" "}
                  <span className="max-md:hidden">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="17"
                      viewBox="0 0 17 17"
                      fill="none"
                    >
                      <path
                        d="M8.33333 16.6667C7.18056 16.6667 6.09722 16.4479 5.08333 16.0104C4.06944 15.5729 3.1875 14.9792 2.4375 14.2292C1.6875 13.4792 1.09375 12.5972 0.65625 11.5833C0.21875 10.5694 0 9.48611 0 8.33333C0 7.18056 0.21875 6.09722 0.65625 5.08333C1.09375 4.06944 1.6875 3.1875 2.4375 2.4375C3.1875 1.6875 4.06944 1.09375 5.08333 0.65625C6.09722 0.21875 7.18056 0 8.33333 0C9.48611 0 10.5694 0.21875 11.5833 0.65625C12.5972 1.09375 13.4792 1.6875 14.2292 2.4375C14.9792 3.1875 15.5729 4.06944 16.0104 5.08333C16.4479 6.09722 16.6667 7.18056 16.6667 8.33333C16.6667 9.48611 16.4479 10.5694 16.0104 11.5833C15.5729 12.5972 14.9792 13.4792 14.2292 14.2292C13.4792 14.9792 12.5972 15.5729 11.5833 16.0104C10.5694 16.4479 9.48611 16.6667 8.33333 16.6667ZM7.5 14.9583V13.3333C7.04167 13.3333 6.64931 13.1701 6.32292 12.8438C5.99653 12.5174 5.83333 12.125 5.83333 11.6667V10.8333L1.83333 6.83333C1.79167 7.08333 1.75347 7.33333 1.71875 7.58333C1.68403 7.83333 1.66667 8.08333 1.66667 8.33333C1.66667 10.0139 2.21875 11.4861 3.32292 12.75C4.42708 14.0139 5.81944 14.75 7.5 14.9583ZM13.25 12.8333C13.8194 12.2083 14.2535 11.5104 14.5521 10.7396C14.8507 9.96875 15 9.16667 15 8.33333C15 6.97222 14.6215 5.72917 13.8646 4.60417C13.1076 3.47917 12.0972 2.66667 10.8333 2.16667V2.5C10.8333 2.95833 10.6701 3.35069 10.3438 3.67708C10.0174 4.00347 9.625 4.16667 9.16667 4.16667H7.5V5.83333C7.5 6.06944 7.42014 6.26736 7.26042 6.42708C7.10069 6.58681 6.90278 6.66667 6.66667 6.66667H5V8.33333H10C10.2361 8.33333 10.434 8.41319 10.5938 8.57292C10.7535 8.73264 10.8333 8.93056 10.8333 9.16667V11.6667H11.6667C12.0278 11.6667 12.3542 11.7743 12.6458 11.9896C12.9375 12.2049 13.1389 12.4861 13.25 12.8333Z"
                        fill="#2A85FF"
                      />
                    </svg>
                  </span>
                </span>
              </div>
              <div className="bg-[#f5f5f5] px-6 py-5 flex flex-col gap-2 border-r-4 border-[#39f] max-md:p-2">
                <span className="text-xs font-bold tracking-[1.5px] text-[#2a85ff] uppercase">
                  MILES PASS RATE
                </span>
                <span className="text-[56px] font-bold text-[#2a85ff] leading-[1.1] max-lg:text-[46px] max-md:text-[42px]">
                  ~76%{" "}
                  <span className="max-md:hidden">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="18"
                      viewBox="0 0 19 18"
                      fill="none"
                    >
                      <path
                        d="M6.33333 17.5L4.75 14.8333L1.75 14.1667L2.04167 11.0833L0 8.75L2.04167 6.41667L1.75 3.33333L4.75 2.66667L6.33333 0L9.16667 1.20833L12 0L13.5833 2.66667L16.5833 3.33333L16.2917 6.41667L18.3333 8.75L16.2917 11.0833L16.5833 14.1667L13.5833 14.8333L12 17.5L9.16667 16.2917L6.33333 17.5ZM7.04167 15.375L9.16667 14.4583L11.3333 15.375L12.5 13.375L14.7917 12.8333L14.5833 10.5L16.125 8.75L14.5833 6.95833L14.7917 4.625L12.5 4.125L11.2917 2.125L9.16667 3.04167L7 2.125L5.83333 4.125L3.54167 4.625L3.75 6.95833L2.20833 8.75L3.75 10.5L3.54167 12.875L5.83333 13.375L7.04167 15.375ZM8.29167 11.7083L13 7L11.8333 5.79167L8.29167 9.33333L6.5 7.58333L5.33333 8.75L8.29167 11.7083Z"
                        fill="#2A85FF"
                      />
                    </svg>
                  </span>
                </span>
              </div>
            </div>
            <p className="text-xs italic text-[#414141] m-0">
              That&rsquo;s why Miles is IMA&rsquo;s Diamond Partner and the
              World&rsquo;s largest CMA course provider
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AI_integreated;
